const { getHost, getResendFormVisibility, setResendFormVisibility } = require('../common');
const { fetcher } = require('../fetcher');
exports.SENDGRID_PING_RECEIVAL_TIME = 30000;
exports.CHECK_EMAIL_DELIVERY_TIMEOUT = 5000;
exports.RETRIES = 7;

document.addEventListener('DOMContentLoaded', () => {
  const emailFormOnPlanPage = document.querySelector('.js-emailmeal-on-diets-page');
  const resendFormCloseButton = document.querySelector('.js-close-resend-form');
  const resendForm = document.querySelector('#resend-form');
  emailFormOnPlanPage && emailFormOnPlanPage.addEventListener('submit', e => exports.submitFormAction(e));

  if (backEndVars.shouldInitEmailDeliveryStatusCheck) {
    exports.initEmailDeliveryStatusCheck(backEndVars.userDietUUID);
  }

  if (resendForm && !getResendFormVisibility(backEndVars.userDietUUID)) {
    resendForm.style.display = 'block';
  }

  //Close resend form
  resendFormCloseButton &&
    resendFormCloseButton.addEventListener('click', function () {
      setResendFormVisibility(backEndVars.userDietUUID, true);
    });
});

exports.submitFormAction = function (e) {
  e.preventDefault();

  const emailDeliverySuccessContainer = document.querySelector('#email-delivery-success');
  const resendEmailBlock = document.querySelector('#resend-email-block');
  const emailDeliveryPending = document.querySelector('#email-delivery-pending');
  const emailSentNotification = document.querySelector('.m-email-sent-notification');

  const fields = document.querySelectorAll('.js-input');
  const valid = [...fields].every(e => e.dataset.valid === 'true');
  if (!valid) {
    const event = new Event('change');
    fields.forEach(input => input.dispatchEvent(event));
    return;
  }

  const uuid = e.currentTarget.querySelector('input[name=uuid]').value;
  const email = e.currentTarget.querySelector('input[name=email]').value;
  const logResend = e.currentTarget.querySelector('input[name=logResend]').value;
  const elementClasses = e.currentTarget.classList;

  // hide all but the "Receiving" box
  emailDeliverySuccessContainer && (emailDeliverySuccessContainer.style.display = 'none');
  resendEmailBlock && (resendEmailBlock.style.display = 'none');
  emailDeliveryPending && (emailDeliveryPending.style.display = 'block');

  fetcher
    .post(getHost() + '/diets/resend', { uuid, email, logResend }, { Accept: 'application/json' })
    .then(data => {
      if (!data) {
        window.location.href = getHost() + '/164';
        return;
      } else if (data.error) {
        window.location.href = getHost() + '/165';
        return;
      }

      if (data.success) {
        if (elementClasses.contains('js-emailmeal-on-diets-page')) {
          exports.initEmailDeliveryStatusCheck(uuid, email);
        } else {
          resendEmailBlock && (resendEmailBlock.style.display = 'none');
          emailSentNotification && (emailSentNotification.style = '');
        }
      } else {
        resendEmailBlock && (resendEmailBlock.style.display = 'block');
        emailDeliveryPending && (emailDeliveryPending.style.display = 'none');
      }
    })
    .catch(() => {
      resendEmailBlock && (resendEmailBlock.style.display = 'block');
      emailDeliveryPending && (emailDeliveryPending.style.display = 'none');
    });
};

exports.initEmailDeliveryStatusCheck = function (uuid, email = '') {
  setTimeout(function () {
    exports.isEmailDelivered(uuid, email);
  }, exports.SENDGRID_PING_RECEIVAL_TIME);
};

exports.isEmailDelivered = function (uuid, email) {
  exports.emailDeliveryServerResponse(uuid, email).then(function (resp) {
    if (exports.receivedResponseShouldBeProcessed(resp)) {
      exports.handleEmailDeliveryStatus(resp);
      return;
    }

    setTimeout(function () {
      exports.checkEmailDelivery(uuid, email, exports.RETRIES);
    }, exports.CHECK_EMAIL_DELIVERY_TIMEOUT);
  });
};

exports.emailDeliveryServerResponse = function (uuid, email = '', lastEmailStatusCheck = false) {
  var queryParameter = email == '' ? '' : '?email=' + encodeURIComponent(email);

  if (lastEmailStatusCheck) {
    queryParameter += queryParameter.length > 0 ? '&last-try=true' : '?last-try=true';
  }

  return fetcher.get(getHost() + '/diets/' + uuid + '/email-delivery-status' + queryParameter, {
    Accept: 'application/json',
  });
};

exports.checkEmailDelivery = function (uuid, email, retries) {
  retries--;

  const lastEmailStatusCheck = retries == 0 ? true : false; // retires will be = 1 on last check

  exports.emailDeliveryServerResponse(uuid, email, lastEmailStatusCheck).then(function (resp) {
    if (exports.receivedResponseShouldBeProcessed(resp)) {
      exports.handleEmailDeliveryStatus(resp);
      return;
    }

    if (retries == 0) {
      exports.handleEmailDeliveryStatus(resp);
      return;
    }

    setTimeout(function () {
      exports.checkEmailDelivery(uuid, email, retries);
    }, exports.CHECK_EMAIL_DELIVERY_TIMEOUT);
  });
};

exports.receivedResponseShouldBeProcessed = function (response) {
  return response.success == true && response.deferred == false;
};

exports.handleEmailDeliveryStatus = function (data) {
  const { reason, delivered, success } = data;
  const undeliveredEmailReason = document.querySelector(
    '#resend-email-block #undelivered-email-message #undelivered-email-reason',
  );
  const undeliveredEmailDelivered = document.querySelector(
    '#resend-email-block #undelivered-email-message .email-status-delivered',
  );
  const undeliveredEmailUndelivered = document.querySelector(
    '#resend-email-block #undelivered-email-message .email-status-undelivered',
  );
  const undeliveredEmailUnknown = document.querySelector(
    '#resend-email-block #undelivered-email-message .email-status-unknown',
  );
  undeliveredEmailReason && (undeliveredEmailReason.innerHTML = reason);

  if (delivered == true || success == true) {
    undeliveredEmailDelivered.style.display = 'inline';
    undeliveredEmailUndelivered.style.display = 'none';
    undeliveredEmailUnknown.style.display = 'none';
  } else {
    undeliveredEmailDelivered.style.display = 'none';
    undeliveredEmailUndelivered.style.display = 'none';
    undeliveredEmailUnknown.style.display = 'inline';
  }

  document.querySelector('.js-emailmeal-on-diets-page input[name=email]').value = ''; // clear any previously entered email address
  document.querySelector('#resend-email-block').style.display = 'block';
  document.querySelector('#email-delivery-pending').style.display = 'none';
};
